import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { scrollContentSubTitle, scrollableContentData } from "../../../../Data/BonusUiData/ScrollbarData";
import { H4, Image, LI, P, UL } from "../../../../AbstractElements";
import { ScrollableContentTitle } from "../../../../Utils/Constants";
import { dynamicImage } from "../../../../Utils";
import ScrollBar from "react-perfect-scrollbar";

export default function ScrollableContent() {
  return (
    <Col xxl={4} md={12}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={ScrollableContentTitle} subTitle={scrollContentSubTitle} />
        <CardBody>
          <ScrollBar className="vertical-scroll scroll-demo scroll-b-none custom-container">
            <UL className="main-lists-content">
              {scrollableContentData &&
                scrollableContentData.map((item, index) => (
                  <LI className={`list-group-item-action list-hover-primary ${index === 0 ? "active" : ""}`} key={index}>
                    <div className="list-wrapper gap-0">
                      <Image className="list-img" src={dynamicImage(`user/${item.image}`)} alt="profile" />
                      <div className="list-content">
                        <H4 className="text-dark">{item.head}</H4>
                        <P>{item.mail}</P>
                        <small className={index !== 0 ? "text-muted" : ""}>{item.small}</small>
                      </div>
                    </div>
                  </LI>
                ))}
            </UL>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
}
